import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Info } from 'react-feather'

import { getTooltipClassName } from '../../lib/helpers/helperFunctions'

const CompassGlobalLinkTooltip: React.FC = () => {
  const content = (
    <>
      Your global link is a unique link for your firm's Compass portal for
      clients. Simply copy the link, share it with clients - they'll then be
      able to complete Compass or create an account. For maximum impact, we
      recommend using this link as part of your client onboarding process or
      during your annual review cycle.
    </>
  )

  return (
    <OverlayTrigger
      placement="auto"
      overlay={
        <Tooltip className={getTooltipClassName(content)}>{content}</Tooltip>
      }
    >
      <Info
        className="text-primary"
        size="15px"
        style={{ marginLeft: '5px' }}
      />
    </OverlayTrigger>
  )
}

export default CompassGlobalLinkTooltip
